import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Navbar, NavItem, Nav } from "reactstrap";
import styles from "./Header.module.scss";
import { Link } from "react-router-dom";

import Menu from "./Menu";

import BestQuoteLogo from "../../images/bestquote_logo_2025.svg";
import BestQuoteLogoWhite from "../../images/bestquote_logo_white.svg";
import MarketFlag from "../../images/Flag-St-Vincent.svg";

function Header() {
  const [isOpen, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <Navbar className={`${styles["navbar"]} sticky-top`} light expand="md">
      <Container fluid className={styles["navbar-container"]}>
        <Nav navbar className={`${styles["left"]} d-md-none`}>
          <NavItem onClick={() => setOpen((state) => !state)}>
            <i
              className={`${styles["navbar-toggler-icon"]} fas ${
                isOpen ? "fa-times" : "fa-bars"
              }`}
            />
          </NavItem>
        </Nav>

        <Link to="/" className={styles["brand"]}>
          <picture>
            <source media="(max-width: 767px)" srcSet={BestQuoteLogoWhite} />
            <source media="(min-width: 768px)" srcSet={BestQuoteLogo} />
            <img
              src={BestQuoteLogo}
              alt="BestQuote - Big Insurance Savings"
              width="150"
            />
          </picture>
        </Link>

        <Menu isOpen={isOpen} />

        <div className={styles["right"]}>
          <a className={`${styles["nav-link"]} ${styles["phone"]}`} href="tel:1-784-453-3300">
            <i className="fas fa-phone-volume" />
            <span className="d-none d-md-inline">1-784-453-3300</span>
          </a>
          <img src={MarketFlag} alt="Market Flag" className={styles["market-flag"]} />
        </div>
      </Container>
    </Navbar>
  );
}

export default Header;
